import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import FilterItems from '../../FilterItems/FilterItems';
import OptionsPanel from 'Components/OptionsPanel/OptionsPanel';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import './VehicleInformation.css';

const VehicleInformation = ({
    clientIdSelected
}) => {
    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [vehicleIdSelected, setVehicleIdSelected] = useState([]);
    const [isActiveFilter, setIsActiveFilter] = useState('S');
    const [files, setFiles] = useState([]);
    const [brandList, setBrandList] = useState(null);
    const [vehicleList, setVehiclesList] = useState(null);
    const [modelName, setModelName] = useState(null);
    const [brandName, setBrandName] = useState(null);

    const readOnlyAttributes = !(inserting || updating);

    const [id, setId] = useState(null);
    const [company, setCompany] = useState(null);
    const [brandId, setBrandId] = useState(null);
    const [modelId, setModelId] = useState(null);
    const [plateNumber, setPlateNumber] = useState(null);
    const [color, setColor] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [dtUpdate, setDtUpdate] = useState(null);
    const [username, setUsername] = useState(null);
    const [creationDate, setCreationDate] = useState(null);
    const [userCreation, setUserCreation] = useState(null);
    const [images, setImages] = useState([]);

    async function loadImages() {
        const response = await ExecuteAxios.api(
            "get",
            `/client-vehicle-image/${vehicleIdSelected[0]}`
        );

        setImages(response);
    }

    useEffect(() => {
        if (vehicleIdSelected?.[0]) {
            loadImages();
        }
    }, [vehicleIdSelected]);

    async function deleteImage(id) {

        const confirmed = window.confirm(
            "Deseja excluir esta imagem?"
        );

        if (!confirmed) {
            return;
        }

        await ExecuteAxios.api(
            "delete",
            `/client-vehicle-image/${id}`
        );

        await loadImages();
    }

    useEffect(() => {
        setVehiclesList([])
        const onReady = async () => {
            await callToSetBrandList();
        };

        onReady();
    }, [])

    useEffect(() => {
        const onReady = async () => {
            await callToSetVehiclesList();
        };

        onReady();
    }, [brandId])

    async function callToSetBrandList() {
        const brandsIds = await ExecuteAxios.api('get', `/vehicle-brand/lookup/`);
        setBrandList(brandsIds);
    }

    async function callToSetVehiclesList() {
        if (brandId) {
            const parameters = { brandId: brandId }
            const vehicleIds = await ExecuteAxios.api('get', `/vehicle/lookup/`, { params: parameters });
            setVehiclesList(vehicleIds);
        }
    }

    const brandOptions = OptionsDataByAttributePath(brandList, ['description'], null, true);
    const vehicleOptions = OptionsDataByAttributePath(vehicleList, ['description'], null, true);


    const attributeList = [
        { name: "id", value: id, setter: setId },
        {
            name: "brandName",
            value: brandName,
            setter: setBrandName
        },
        {
            name: "modelName",
            value: modelName,
            setter: setModelName
        },
        {
            name: "company",
            value: company,
            setter: setCompany
        },
        {
            name: "company",
            value: company,
            setter: setCompany
        },

        {
            name: "brandId",
            value: brandId,
            setter: setBrandId,
            comboboxOptions: brandOptions
        },

        {
            name: "modelId",
            value: modelId,
            setter: setModelId,
            comboboxOptions: vehicleOptions
        },

        {
            name: "plateNumber",
            value: plateNumber,
            setter: setPlateNumber
        },

        {
            name: "color",
            value: color,
            setter: setColor
        },

        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                {
                    field: 'isActive',
                    condition: 'VALUE_EQUALS',
                    arrayValue: ['S']
                }
            ]
        },

        {
            name: "dtUpdate",
            value: dtUpdate,
            setter: setDtUpdate
        },

        {
            name: "username",
            value: username,
            setter: setUsername
        },

        {
            name: "creationDate",
            value: creationDate,
            setter: setCreationDate
        },

        {
            name: "userCreation",
            value: userCreation,
            setter: setUserCreation
        }
    ];

    useEffect(() => {
        reloadListItem()
    }, [clientIdSelected, isActiveFilter]);

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setVehicleIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListItem()

        if ((!vehicleIdSelected || vehicleIdSelected.length !== 1) && updating) {
            setUpdating(false)
        }

        if (!vehicleIdSelected || vehicleIdSelected.length > 1) {
            setVehicleIdSelected([])
        }

    }, [updating]);

    useEffect(() => {
        if (vehicleIdSelected && vehicleIdSelected.length === 1) {
            fetchDataDetail(vehicleIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }

    }, [vehicleIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {

        const parameters = { clientId: clientIdSelected ?? 0, isActive: isActiveFilter }

        const items = await ExecuteAxios.api(
            'get',
            `/client-vehicle/grid/`,
            { params: parameters }
        );

        setRecordsItemByUserId(items);

        RemoveIdsNotFound.remove(
            items,
            setVehicleIdSelected,
            vehicleIdSelected
        );
    }

    const fetchDataDetail = async (vehicleIdSelected) => {

        const parameters = {
            id: vehicleIdSelected ? vehicleIdSelected : 0
        }

        const item = await ExecuteAxios.api(
            'get',
            `/client-vehicle/detail/`,
            { params: parameters }
        )

        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!vehicleIdSelected || vehicleIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {

        if (!updating && !inserting) {

            return (
                <PanelListDefault
                    onUpdateIdSelected={setVehicleIdSelected}
                    idsSelected={vehicleIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        }

        return (
            <AutomaticallyListedAttributes
                list={attributesDetailItemPanel}
                attributeList={attributeList}
                readOnlyAttributes={readOnlyAttributes}
            />
        )
    }

    async function postVehicleInformation() {
        try {
            setLoadingItemPanel(true);

            const response = await ExecuteAxios.api(
                'post',
                `/client-vehicle/`,
                {
                    clientId: clientIdSelected,
                    vehicleId: modelId,
                    plateNumber: plateNumber,
                    color,
                    isActive
                }
            );

            if (response) {
                await reloadListItem();
                setInserting(false);
            }

            return response;
        } finally {
            setLoadingItemPanel(false);
        }
    }

    async function postImage(selectedFiles) {
        try {
            setLoadingItemPanel(true);

            const formData = new FormData();

            formData.append(
                "clientVehicleId",
                vehicleIdSelected[0]
            );

            selectedFiles.forEach(file => {
                formData.append("files", file);
            });

            return await ExecuteAxios.api(
                "post",
                "/client-vehicle-image", // sem barra no final
                formData
            );

        } finally {
            setLoadingItemPanel(false);
        }
    }

    async function putVehicleInformation() {
        try {
            setLoadingItemPanel(true);

            const parameters = {
                id,
                clientId: clientIdSelected,
                vehicleId: modelId,
                plateNumber: plateNumber,
                color,
                isActive
            };

            const response = await ExecuteAxios.api(
                'put',
                `/client-vehicle/`,
                parameters
            );

            if (response) {
                await reloadListItem();
                setUpdating(false);
            }

            return response;
        } finally {
            setLoadingItemPanel(false);
        }
    }

    async function putImage() {

        try {

            setLoadingItemPanel(true);

            const formData = new FormData();

            if (files && files.length > 0) {

                files.forEach(file => {
                    formData.append("files", file);
                });

            }

            const response = await ExecuteAxios.api(
                'put',
                `/client-vehicle/`,
                formData
            );

            if (response) {

                await reloadListItem();

                setUpdating(false);

                setFiles([]);
            }

            return response;

        } finally {

            setLoadingItemPanel(false);
        }
    }

    const baseUrl = "https://www.perichert.com";

    return (
        <Panel
            className={'main-modal'}
            style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: 'calc(50% - 15px)',
                marginLeft: '0px'
            }}>
            <LoadingIndicator loaded={!loadingItemPanel}>

                <FilterItems
                    isActiveFilter={isActiveFilter}
                    onUpdatesIsActiveFilter={setIsActiveFilter}
                />
                <OptionsPanel
                    height='83%'
                    options={[
                        {
                            label: 'Veículos',
                            component: (
                                <Panel
                                    style={itemPanelStyle}
                                    titlePage={'Veículos'}
                                    setUpdating={setUpdating}
                                    setInserting={setInserting}
                                    inserting={inserting}
                                    updating={updating}
                                    enableEdit={true}
                                    canEdit={
                                        vehicleIdSelected &&
                                        vehicleIdSelected.length == 1 &&
                                        clientIdSelected
                                    }
                                    putFunction={putVehicleInformation}
                                    enableNewRecord={true}
                                    canNewRecord={
                                        clientIdSelected
                                    }
                                    postFunction={postVehicleInformation}
                                    canViewCRUD={true}
                                    readOnly={false}
                                    recordsSelected={vehicleIdSelected}
                                    viewOnlyOneRecordCRUD={true}
                                    resetVariables={() => {
                                        ResetVariables.resetVariables(attributeList)
                                    }}
                                    dataListedAttributes={attributesDetailItemPanel}
                                    attributeList={attributeList}
                                    onUpdateIdSelected={setVehicleIdSelected}
                                >
                                    {getItemPanelListOrDetail()}
                                </Panel>
                            )
                        },

                        ...(vehicleIdSelected && vehicleIdSelected.length == 1
                            ? [{
                                label: 'Fotos',
                                component: (
                                    <div className="photos-container">

                                        <div className="upload-container">

                                            <input
                                                type="file"
                                                multiple
                                                style={{ border: 'none' }}
                                                onChange={async (e) => {
                                                    try {
                                                        const selectedFiles = [...e.target.files];

                                                        if (selectedFiles.length > 0) {
                                                            await postImage(selectedFiles);
                                                            await loadImages();
                                                        }
                                                    } finally {
                                                        e.target.value = null;
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="images-container">
                                            {images?.map(image => (
                                                <div
                                                    key={image.id}
                                                    className="image-item"
                                                >

                                                    <img
                                                        src={`${baseUrl}/uploads/${image.url.replace(/\\/g, "/")}`}
                                                        className="vehicle-image"
                                                    />

                                                    {/* 
                                                    <img
                                                        src={`http://localhost:8084/${image.url.replace(/\\/g, "/")}`}
                                                        alt="Foto do veículo"
                                                        className="vehicle-image"
                                                    />
                                                    */}

                                                    <button
                                                        type="button"
                                                        className="delete-button"
                                                        onClick={() => deleteImage(image.id)}
                                                        title="Excluir imagem"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                )
                            }]
                            : [])
                    ]}
                />
            </LoadingIndicator>
        </Panel>
    );

}

export default VehicleInformation;